import { Button, FormHelperText, Grid, TextField, Typography } from "@mui/material"
import axios from "axios"
import { useEffect, useState } from "react"
import { SERVER_URI } from "../utils/config"

const styles = {
	grid: {
		marginTop: 3,
	},
	gridItem: {
		margin: 1,
	},
}

const LoginPage = (props) => {
	const { setAuthenticated } = props
	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
	const [helperText, setHelperText] = useState("")

	const handleUsername = (event) => {
		setUsername(event.target.value)
		setHelperText("")
	}

	const handlePassword = (event) => {
		setPassword(event.target.value)
		setHelperText("")
	}

	const handleAuthenticate = async (event) => {
		try {
			const response = await axios({
				method: "post",
				url: `${SERVER_URI}/login`,
				data: {
					username: username,
					password: password,
				},
			})
			if (response.status === 200) {
				localStorage.setItem("adminToken", response.data.token)
				axios.defaults.headers.common["Authorization"] = `Token ${response.data.token}`
				setAuthenticated(true)
			}
		} catch (e) {
			setHelperText("Väärä käyttäjätunnus tai salasana!")
			console.log("ERROR: ", e.message)
		}
	}

	useEffect(() => {
		const checkToken = async () => {
			const token = localStorage.getItem("adminToken")
			if (token) {
				axios.defaults.headers.common["Authorization"] = `Token ${token}`
				try {
					const response = await axios.get(`${SERVER_URI}/verify-token`)
					if (response.status === 200) {
						setAuthenticated(true)
					}
				} catch (e) {
					localStorage.removeItem("adminToken")
					axios.defaults.headers.common["Authorization"] = ""
					console.log("ERROR: ", e.message)
				}
			}
		}
		checkToken()
	}, [setAuthenticated])

	return (
		<Grid container component={"form"} justifycontent="flex-start" sx={styles.grid}>
			<Grid item xs={12} md={8} sx={styles.gridItem}>
				<Typography variant="h6">Kirjautuminen:</Typography>
			</Grid>
			<Grid item xs={12} md={8} sx={styles.gridItem}>
				<TextField id="user" label="Käyttäjätunnus:" variant="outlined" onChange={handleUsername} />
			</Grid>
			<Grid item xs={12} md={8} sx={styles.gridItem}>
				<TextField
					id="password"
					type="password"
					label="Salasana:"
					variant="outlined"
					autoComplete={"password"}
					onChange={handlePassword}
				/>
				<FormHelperText error>{helperText}</FormHelperText>
			</Grid>
			<Grid item xs={12} md={8} sx={styles.gridItem}>
				<Button variant="contained" color="primary" size="large" onClick={() => handleAuthenticate()}>
					Kirjaudu
				</Button>
			</Grid>
		</Grid>
	)
}
export default LoginPage
